<div class="mobile__overlay" aria-modal="true" cdkTrapFocus>
    <div class="mobile__container">
        <div class="mobile__header">
            <ng-content select="[overlay-header]"></ng-content>
        </div>
        <div class="mobile__body">
            <ng-content select="[overlay-body]"></ng-content>
        </div>
        @if (!hideFooter()) {
            <div class="mobile__footer">
                <ng-content select="[overlay-footer]"></ng-content>
            </div>
        }
    </div>
</div>
